import { createAction } from 'redux-actions';

export const getJobPosts = createAction('GET_JOB_POSTS');

export const setUserJobPosts = createAction('SET_USER_JOB_POSTS');

export const setJobPost = createAction('SET_JOB_POST');

export const deleteJobPost = createAction('DELETE_JOB_POST');

export const editJobPost = createAction('EDIT_JOB_POST');

export const publishJobPost = createAction('PUBLISH_JOB_POST');

export const getAllJobPosts = createAction('GET_JOB_POSTS');

export const setAllJobPosts = createAction('SET_ALL_JOB_POSTS');

export const saveRecruiterJobPost = createAction('SAVE_RECRUITER_JOB_POST');

export const deleteRecruiterJobPost = createAction('DELETE_RECRUITER_JOB_POST');

export const startCreateJobPostSubmit = createAction('START_CREATE_JOB_POST_SUBMIT');

export const resolveCreateJobPostSubmit = createAction('RESOLVE_CREATE_JOB_POST_SUBMIT');

export const setJobPostsLoading = createAction<boolean>('SET_JOB_POSTS_LOADING');
